export default "__VITE_ASSET__Yos1YbLO__"